(function () {

  let renderTimer = null;

  function renderBazaarvoice() {

    if (
      !window.BV ||
      !BV.rating_summary ||
      !BV.swat_reviews
    ) {
      return;
    }

    const rating = document.querySelector(
      '[data-bv-show="rating_summary"]'
    );

    const reviews = document.querySelector(
      '[data-bv-show="reviews"]'
    );

    if (!rating || !reviews) {
      return;
    }

    try {

      rating.removeAttribute("data-bv-ready");
      reviews.removeAttribute("data-bv-ready");

      BV.rating_summary.render(rating);
      BV.swat_reviews.render(reviews);

    } catch (e) {
      console.error("Bazaarvoice render failed", e);
    }
  }

  function scheduleRender() {

    clearTimeout(renderTimer);

    renderTimer = setTimeout(renderBazaarvoice, 300);

  }

  document.addEventListener("DOMContentLoaded", scheduleRender);

  document.addEventListener("variant:changed", scheduleRender);

  if (
    window.Frame &&
    Frame.EventBus &&
    Frame.EventBus.listen
  ) {
    Frame.EventBus.listen(
      "ProductForm:replaced",
      scheduleRender
    );
  }

})();